import React, { useState } from 'react'
import { Alert, Snackbar } from '@mui/material'
import { GroupsRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { CROWD_WARNING_TEXT } from './visionState'

// Design v2 (Indicadores.dc.html, PO 2026-10-22): shown once, when the excess starts, and closed by itself.
const AUTO_HIDE_MS = 6000

// Story 213 C11.8 — too many people, without covering (RN18), over the app or the overlay. Design v2 (PO 2026-10-22): no
// floating box any more — while the excess lasts the amber badge of the camera icon says it (VisionChip); when it starts,
// one snackbar of MIC like the others. The guard mounts this warning when the excess starts and unmounts it when it ends,
// so it shows once per excess: once closed it does not come back, even if the count changes.
const VisionCrowdWarning = ({ state }) => {
  const { t_ } = useSmartTranslation()
  const [open, setOpen] = useState(true)

  return (
    <Snackbar
      open={open}
      autoHideDuration={AUTO_HIDE_MS}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert role='status' severity='warning' variant='filled' icon={<GroupsRounded />} onClose={() => setOpen(false)}>
        {/* i18next interpolates; the replace covers a translator that returns the template as it is */}
        {t_(CROWD_WARNING_TEXT, { count: state.peopleCount, max: state.maxPeople })
          .replace('{{count}}', String(state.peopleCount))
          .replace('{{max}}', String(state.maxPeople))}
      </Alert>
    </Snackbar>
  )
}

export default VisionCrowdWarning
